export default {
	COPIED_TO_CLIPBOARD: 'Text copied to clipboard',
	COPIED_TO_CLIPBOARD_FAIL: 'Failed to copy text to clipboard',
};
